import { Checkbox } from '@/components/ui/Checkbox';
import { ButtonLink } from '@/components/ui/Link';
import { Device } from '@/generated/graphql';
import { DeviceConfig } from '@/models/device.models';
import { FeatureName } from '@/models/role.models';
import hasPermission from '@/utils/permission.function';
import { renderDeviceStateBadge } from '@/utils/state';
import { ColumnDef } from '@tanstack/react-table';
import { Navigation } from 'lucide-react';

export default function deviceSiteColumns(): ColumnDef<Device>[] {
  const columns: ColumnDef<Device>[] = hasPermission(
    FeatureName.ASSIGN_DEVICES_TO_SITE,
  )
    ? [
        {
          id: 'select',
          header: ({ table }) => (
            <Checkbox
              checked={
                table.getIsAllPageRowsSelected() ||
                (table.getIsSomePageRowsSelected() && 'indeterminate')
              }
              onCheckedChange={(value) =>
                table.toggleAllPageRowsSelected(!!value)
              }
              aria-label="Select all"
            />
          ),
          cell: ({ row }) => (
            <Checkbox
              checked={row.getIsSelected()}
              onCheckedChange={(value) => row.toggleSelected(!!value)}
              aria-label="Select row"
            />
          ),
          size: 50,
        },
      ]
    : [];

  const deviceSiteColumns: ColumnDef<Device>[] = [
    ...columns,
    {
      accessorKey: 'name',
      header: 'Name',
    },
    {
      accessorKey: 'serial',
      header: 'Serial',
    },
    {
      accessorKey: 'status',
      header: 'Status',
      cell: ({ row }) => {
        return renderDeviceStateBadge(
          (row?.original?.config as DeviceConfig)?.state,
        );
      },
      enableSorting: true,
      size: 100,
    },
    {
      accessorKey: 'action',
      header: '',
      cell: ({ row }) => (
        <ButtonLink
          variant="outline"
          size={'icon-sm'}
          className="ms-auto flex"
          to={`/devices/${row?.original.id}`}
        >
          <Navigation />
        </ButtonLink>
      ),
    },
  ];
  return deviceSiteColumns;
}
